import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { MainService } from '../../../services/main.service';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactComponent implements OnInit {

    subjectList: Array<any>;
    mysubject: any;

    constructor(private viewportScroller: ViewportScroller, 
        private mainService: MainService,
        private toastr: ToastrService,
        private translate: TranslateService) {}

    public onClick(elementId: string): void { 
        this.viewportScroller.scrollToAnchor(elementId);
    }

    async ngOnInit() {
        this.subjectList = await this.mainService.getSubjectList();
        console.log('resp >>>>', this.subjectList);
    }

    submit(form: NgForm){
        const values = form.value;
        var name = values.name;
        console.log(name);
        
        var email = values.email;
        console.log(email);

        var number = values.number;
        console.log(number);
        
        var subject = values.subject;
        console.log(subject);
        
        var message = values.message;
        console.log(this.mysubject);


			this.mainService.postContact({
				"nombre": name,
				"email": email,
				"asunto":this.mysubject.name,
				"telefono": number,
				"mensaje": message,
			}).subscribe((res:any)=>{
				form.resetForm();
				this.toastr.success(this.translate.instant('contact.success'));
			}, (err)=>{
				this.toastr.error(this.translate.instant('contact.error'));
			});

    }

}